import { UserUI } from '@src/models';

import { UserModel } from '../types';

export const mapUserUIToUserModel = (users: Array<UserUI>): Array<UserModel> => {
  return users
    .filter(user => user.id && user.fullName)
    .map(user => {
      return {
        userId: user.id!,
        userName: user.fullName!,
        online: false,
      };
    });
};
